module.exports = __webpack_public_path__ + "media/images/shop/whiteboard-d5b3a2867b8b66e7282988f4eb530f4e.jpg";